import lang from '@/lang'
import { toast } from '@/modules/base/components/toast/toastConfig'
import { fetchSubscriptionData } from '@/redux/ducks/subscription/details'

const NOT_BOOKED = 'NOT_BOOKED'

interface RequestError {
  statusCode?: number
  body?: {
    meta?: {
      publicApi?: { code: string }[]
    }
  }
}

export const isPublicApiNotBookedError = (error: unknown): boolean => {
  const { statusCode, body } = (error ?? {}) as RequestError
  return statusCode === 403 && body?.meta?.publicApi?.[0]?.code === NOT_BOOKED
}

// Returns true when the error was the missing add-on, so callers can skip their generic error handling.
export const handlePublicApiNotBooked = (error: unknown): boolean => {
  if (!isPublicApiNotBookedError(error)) return false

  toast.showToast({ type: 'error', message: lang.marketplace.publicApi.notBookedMessage })
  fetchSubscriptionData(true).catch(() => {})
  return true
}

// fine-uploader reports failures as an XHR, so the status and JSON body are mapped to the shape `request` rejects with.
export const toUploadError = (xhr?: XMLHttpRequest): RequestError | null => {
  if (xhr?.status !== 403) return null

  try {
    return { statusCode: xhr.status, body: JSON.parse(xhr.responseText) }
  } catch {
    return null
  }
}
